import axios from 'axios'
import { Toast } from 'mint-ui'
import router from '../router'
import Cookies from 'js-cookie'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 30000, // 请求超时时间
  headers: { 'AJAX-PF-CODE': 'share' } // 表明该请求来自于哪一个系统
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['ZY_TRANSID'] = Math.random()
      .toString(36)
      .substr(2)
    let token = Cookies.get('token')
    if (token) {
      config.headers['USER_TOKEN_HEAD'] = token
    }
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/json'
      if (config.data) {
        config.data = JSON.stringify(config.data)
      }
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    let code = response.data.code

    // 正常
    if (code === 1) {
      return response.data
    }

    if (code === 9201001) {
      Cookies.remove('token', { domain: process.env.VUE_APP_COOKIES_DOMAIN })
      router.push({
        path: '/login',
        query: { logout: +new Date(), redirect_uri: location.href }
      })
      return Promise.reject(response.data)
    }
    // 应用程序错误
    // if (code === 100001) {
    //   Toast({
    //     message: '应用程序错误',
    //     duration: 5000
    //   })
    //   return Promise.reject(response.data)
    // }
    // 30006用户已存在,30012用户手机已存在,30402第三方登录未注册
    let codeWhiteList = [30006, 30012, 30402]
    if (codeWhiteList.indexOf(code) === -1) {
      Toast({
        message: response.data.message,
        duration: 5000
      })
    }
    return Promise.reject(response.data)
  },
  error => {
    Toast({
      message: '请求接口错误',
      duration: 5000
    })
    return Promise.reject(error)
  }
)

export default service
